<template>
  <article
    class="message"
    v-if="value"
    :class="messageClass">
    <button
      class="delete"
      :class="buttonClass"
      v-if="closable"
      @click="close()">
    </button>
    <div class="message-body">
      <slot>
      </slot>
      <span v-if="message">
        {{ message }}
      </span>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    type: {
      type: String
    },
    closable: {
      type: Boolean,
      default: false
    },
    message: {
      type: [String, Number]
    }
  },
  computed: {
    messageClass() {
      return {
        'is-info': this.type == 'info',
        'is-success': this.type == 'success',
        'is-warning': this.type == 'warning',
        'is-danger': this.type == 'danger'
      }
    },
    buttonClass() {
      return {
        'is-info': this.type == 'info',
        'is-success': this.type == 'success',
        'is-warning': this.type == 'warning',
        'is-danger': this.type == 'danger'
      }
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
}
</script>
